import React, { useState, useEffect } from "react";
import GameButton from "./components/GameButton";
import "./styles/App.css";
import { Link } from "react-router-dom";

export default function Home() {
    const puzzlePiece = "\u{1F9E9}";

    // State for the cat's position, direction, and image
    const [catPosition, setCatPosition] = useState({ x: 50, y: 50 });
    const [catDirection, setCatDirection] = useState("right"); // Track direction
    const [catImage, setCatImage] = useState("/forward-cat.png"); // Default still image
    const [trail, setTrail] = useState([]); // Grass trail
    const [showPopup, setShowPopup] = useState(false); // Popup visibility
    const [isMoving, setIsMoving] = useState(false); // Track if the cat is moving

    // Handle keyboard input for movement
    useEffect(() => {
        const handleKeyDown = (e) => {
            setShowPopup(false); // Hide popup by default
            setTrail((prevTrail) => [
                ...prevTrail,
                { x: catPosition.x, y: catPosition.y, id: Date.now() },
            ]);

            let moved = false;

            switch (e.key) {
                case "w":
                case "ArrowUp":
                    setCatPosition((prev) => ({ ...prev, y: prev.y - 10 }));
                    moved = true;
                    break;
                case "a":
                case "ArrowLeft":
                    setCatPosition((prev) => ({ ...prev, x: prev.x - 10 }));
                    setCatDirection("left"); // Update direction to left
                    moved = true;
                    break;
                case "s":
                case "ArrowDown":
                    setCatPosition((prev) => ({ ...prev, y: prev.y + 10 }));
                    moved = true;
                    break;
                case "d":
                case "ArrowRight":
                    setCatPosition((prev) => ({ ...prev, x: prev.x + 10 }));
                    setCatDirection("right"); // Update direction to right
                    moved = true;
                    break;
                case "g":
                    // Simulate button press if near a button
                    if (isNearButton(catPosition)) {
                        alert("Button pressed!");
                    }
                    break;
                default:
                    break;
            }

            if (moved) {
                setIsMoving(true); // Set moving state to true
            }
        };

        const handleKeyUp = () => {
            setIsMoving(false); // Set moving state to false when keys are released
        };

        window.addEventListener("keydown", handleKeyDown);
        window.addEventListener("keyup", handleKeyUp);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
            window.removeEventListener("keyup", handleKeyUp);
        };
    }, [catPosition]);

    // Update the cat's image based on movement
    useEffect(() => {
        if (isMoving) {
            setCatImage("/cat.gif"); // Set to moving image
        } else {
            setCatImage("/forward-cat.png"); // Set to still image
        }
    }, [isMoving]);

    // Remove grass trail after 3 seconds
    useEffect(() => {
        const interval = setInterval(() => {
            setTrail((prevTrail) => prevTrail.slice(1));
        }, 3000);
        return () => clearInterval(interval);
    }, []);

    // Check if the cat is near a button
    const isNearButton = (position) => {
        const buttons = document.querySelectorAll(".gameButton");
        for (let button of buttons) {
            const rect = button.getBoundingClientRect();
            if (
                position.x >= rect.left - 20 &&
                position.x <= rect.right + 20 &&
                position.y >= rect.top - 20 &&
                position.y <= rect.bottom + 20
            ) {
                setShowPopup(true); // Show popup when near a button
                return true;
            }
        }
        return false;
    };

    return (
        <div className={"container"}>
            <div className={"homePage"}>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100vw",
                        justifyContent: "center",
                    }}
                >
                    <p className={"Header"}>
                        <Link
                            style={{
                                border: "none",
                                backgroundColor: "white",
                                color: "white",
                            }}
                            to="./admin"
                        >
                            {puzzlePiece}{" "}
                        </Link>
                        Photo Puzzles
                    </p>
                </div>
                <div className="cat-instructions">
                    <p>
                        Use the arrow keys or WASD to move the cat around. 
                    </p>
                    <p>
                        Press "G" to interact with buttons. 
                    </p>
                </div>

                <div className={"gameButton"}>
                    <GameButton title="Guess the spot"></GameButton>
                </div>

                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-around",
                        flexDirection: "row",
                        width: "90vw",
                    }}
                >
                    <div className={"gameButton"}>
                        <GameButton title="Picture Trivia" />
                    </div>

                    <div className={"gameButton"}>
                        <GameButton title="Story Creation" />
                    </div>

                    <div className={"gameButton"}>
                        <GameButton title="Memory Game" />
                    </div>
                </div>

                {/* Cat */}
                <div
                    style={{
                        position: "absolute",
                        top: `${catPosition.y}px`,
                        left: `${catPosition.x}px`,
                        width: "50px",
                        height: "50px",
                        backgroundImage: `url('${catImage}')`, // Dynamically set the cat image
                        backgroundSize: "cover",
                        transform: catDirection === "left" ? "scaleX(-1)" : "scaleX(1)", // Flip horizontally when moving left
                        zIndex: 10,
                    }}
                ></div>

                {/* Grass Trail */}
                {trail.map((t) => (
                    <div
                        key={t.id}
                        className="grass-trail"
                        style={{
                            position: "absolute",
                            top: `${t.y + 25}px`,
                            left: `${t.x}px`,
                            width: "25px",
                            height: "25px",
                            backgroundImage: "url('/grass.png')", // Use grass.png as the background
                            backgroundSize: "cover",
                            backgroundRepeat: "no-repeat",
                            opacity: 0.8,
                            zIndex: 5,
                        }}
                    ></div>
                ))}

                {/* Popup */}
                {showPopup && (
                    <div
                        style={{
                            position: "absolute",
                            top: "10px",
                            right: "10px",
                            backgroundColor: "rgba(0, 0, 0, 0.7)",
                            color: "white",
                            padding: "10px",
                            borderRadius: "5px",
                            zIndex: 20,
                            animation: "fadeIn 0.5s",
                        }}
                    >
                        Press "G" to press the button!
                    </div>
                )}
            </div>
        </div>
    );
}